/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { headerAboutMeConfig } from '../../config/header.config';
export interface IHeaderAboutMePluginMethods extends IPluginMethodMap {
  getHeaderAboutMeSync(args?: any): any;
}

export class HeaderAboutMePlugin implements IAgentPlugin {
  readonly methods: IHeaderAboutMePluginMethods;

  constructor() {
    this.methods = {
      getHeaderAboutMeSync: this.getHeaderAboutMeSync.bind(this),
    };
  }

  getHeaderAboutMeSync(args?: any) {
    return {
      header: headerAboutMeConfig,
    };
  }
}
